module.exports = __webpack_public_path__ + "img/log-dian.621ae266.png";